import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute: React.FC = () => {
  const { isLoggedIn, loading } = useAuth();

  if (loading) {
    return <div>Loading</div>;
  }

  return isLoggedIn ? <Outlet /> : <Navigate to="/auth" />;
};

export default ProtectedRoute;
